import React, { useEffect } from "react";
import { EmptyState } from "src/components/EmptyState";
import { GenericError } from "src/components/Feedback/GenericError";
import NoAlarmSvg from "src/images/no-alarm.svg?react";
import { EligibilityServiceError as ErrorClass } from "src/services/eligibility/useEligibilityService";

type Props = {
  error: Error;
};
export const EligibilityServiceError: React.FC<Props> = ({ error }) => {
  useEffect(() => {
    console.error(error);
  }, [error]);
  if (error instanceof ErrorClass) {
    return (
      <EmptyState
        paddingBottom={10}
        description="Our engines are not powering up. Try again later."
        heading="Unable to check eligibility"
        Svg={NoAlarmSvg}
      />
    );
  }

  return <GenericError error={error} />;
};
